import { render, staticRenderFns } from "./sysAdmissionStatus.vue?vue&type=template&id=2292c2e6&"
import script from "./sysAdmissionStatus.vue?vue&type=script&lang=js&"
export * from "./sysAdmissionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports